export { data } from "./data"
export { component } from "./component"
export { theme } from "./theme"



// WEBPACK FOOTER //
// ./src/store/reducer/index.js